<script>
  import {External, M} from "../../external";
  import VideoAnalytic from "../Analytic/VideoAnalytic.svelte";
  import {formatSecondsTimeStamp, totalViewCountView} from "../static";

  export let videoObject = {};
  export let folder;
  export let videoFolders = {};
  export let showEditVideoMeta;
  export let moveVideo;
  export let removeVideo;
  export let showSelect = false;
  export let selectVideo = () => {};

  let optionsInstance;

  let availableOptions = {
    analytic: {
      text: M.ANALYTICS,
      icon: "fa-chart-line",
      tag: "analytic"
    },
    move: {
      text: M.MOVE,
      icon: "fa-folder",
      tag: "move"
    },
    delete: {
      text: M.DELETE,
      icon: "fa-trash",
      tag: "delete"
    },
    loading: {
      text: M.LOADING,
      icon: "fa-spinner",
      tag: "loading"
    }
  }

  let onOptionsClick = () => {
    let items = [];
    if (videoObject.jobStatus === 'COMPLETE') {
      items.push(availableOptions.analytic);
      items.push(availableOptions.move);
    }
    if (videoObject.jobStatus === 'COMPLETE' || videoObject.jobStatus === 'ERROR') {
      items.push(availableOptions.delete);
    }
    if (items.length === 0) {
      return;
    }
    External.Tools.showTooltipOptions(optionsInstance, items, (target, idx, text, tag) => {
      switch (tag) {
        case 'analytic':
          showAnalyticPopup();
          break;
        case 'move':
          setTimeout(chooseFolderToMoveVideo, 1);
          break;
        case 'delete':
          removeVideo(videoObject);
          break;
      }
    });
  }

  let chooseFolderToMoveVideo = () => {
    let foldersToChoose = [];
    for (const fId in videoFolders) {
      let f = videoFolders[fId];
      if (f.name !== folder.name) {
        let item = {
          text: f.name,
          icon: "fa-folder-o",
          tag: f.id
        }
        foldersToChoose.push(item);
      }
    }
    External.Tools.showTooltipOptions(optionsInstance, foldersToChoose, (target, idx, text, tag) => {
      moveVideo(folder.id, tag, videoObject.id);
    });
  }

  let showAnalyticPopup = () => {
    External.Tools.showWindow({
      title: '',
      height: 750,
      width: 1000,
      isModal: false,
      withDarkBackground: true,
      showCloseButton: true,
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
              new VideoAnalytic({
                target: popup.getContentArea(),
                props: {
                  id: videoObject.elementId,
                  type: 'video'
                }
              })
          );
        }
      }
    });
  }

</script>


<div class="video-object crm-folder col20 f-left flex align center space-between" on:click={() => showEditVideoMeta(videoObject.id)}>
  <div class="flex align-center">
    <div class="crm-folder-thumb-outer flex align-center justify-center">
      {#if videoObject.jobStatus === 'COMPLETE'}
        <span class="crm-folder-thumb " style="background-image: url(&quot;{External.getThumbnailsFromBase(videoObject.thumbnailFileBase, '640x480') + videoObject.thumbnailFileName  + '?format=webp'}&quot;);"></span>
      {:else if videoObject.jobStatus === 'ERROR'}
        <div class="checkout-spinner-wrapper t-center checkout-spinner-wrapper-small">
          <h4 class="error-text">{M.ERROR}</h4>
        </div>
      {:else}
        <div class="checkout-spinner-wrapper t-center checkout-spinner-wrapper-small">
          <div class="checkout-spinner"></div>
          <h4>{M.PROCESSING}</h4>
        </div>
      {/if}
    </div>
    <div class="crm-folder-info flex flex-col">
      <h3>{videoObject.title}</h3>
      <div>
        <span class="video-stat-wrapper">{formatSecondsTimeStamp(videoObject.durationInMs / 1000)}</span>
        <span class="video-stat-wrapper">{M.LAST_UPDATE} {External.Tools.dateToString(new Date(videoObject.updatedAt))}</span>
      </div>
    </div>
  </div>
  <div class="crm-folder-stats flex align-center flex-none">
    <!--{#if videoObject.jobStatus === 'COMPLETE'}-->
    <!--  <a on:click|stopPropagation={() => {showAnalyticPopup();}} bind:this={folderChooser}  class="small-button blue rounded-effect mr-5 visibility-hidden">Analytics</a>-->
    <!--  <a on:click|stopPropagation={() => {chooseFolderToMoveVideo();}} bind:this={folderChooser}  class="small-button blue rounded-effect mr-5 ml-0 visibility-hidden">Move</a>-->
    <!--{/if}-->
    <!--{#if videoObject.jobStatus === 'COMPLETE' || videoObject.jobStatus === 'ERROR'}-->
    <!--  <a on:click|stopPropagation={() => removeVideo(videoObject)} class="small-button blue rounded-effect mr-5 visibility-hidden ml-0">Delete</a>-->
    <!--{/if}-->
    {#if showSelect && videoObject.jobStatus === 'COMPLETE'}
      <a on:click|stopPropagation={() => selectVideo(videoObject)} class="middle-button blue rounded-effect mr-5 ml-0">{M.SELECT}</a>
    {/if}
    <div class="f-left flex-centered">
      <a class="circle-button-small rounded-effect mr-5" on:click|stopPropagation={onOptionsClick} bind:this={optionsInstance}>
        <i class="fa-solid fa-ellipsis"></i>
      </a>
    </div>
    <div class="crm-folder-info-wrapper">
      {totalViewCountView(videoObject.totalViews)}<p>{M.VIEWS}</p>
    </div>
  </div>
  <!--
  <div class="hide-video-object-btn crm-folder-stats flex align-center">
    <button class="middle-button red rounded-effect" on:click={() => removeVideo(folder, videoObject.name)}>
      <span class="material-icons-outlined">delete</span>
    </button>
    <button class="middle-button blue rounded-effect" on:click={() => {chooseFolderToMoveVideo();}} bind:this={folderChooser}>
      <span class="material-icons-outlined">drive_file_move</span>
    </button>
  </div>-->
</div>


<style>

  .hide-video-object-btn {
    visibility: hidden;
  }

  .video-object:hover > .hide-video-object-btn {
    visibility: visible;
  }
</style>
